import React, { useEffect, useState } from 'react';
import { ArrowRight, Hourglass } from 'lucide-react';
import { API } from '../siteConfig';
import { SectionHead } from './SectionHead';

const fmtDate = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

const Stats = ({ s }) => (
  <>
    <dl className="mk-tr-stats" data-testid="track-record-stats">
      <div><dt>Graded outlooks</dt><dd className="mk-num">{s.sample_size.toLocaleString('en-US')}</dd></div>
      <div><dt>Date range</dt><dd className="mk-num mk-tr-range">{fmtDate(s.first_date)} to {fmtDate(s.last_date)}</dd></div>
      <div><dt>Hit rate</dt><dd className="mk-num">{s.hit_rate.toFixed(1)}%</dd></div>
      <div><dt>Average direction-adjusted return</dt><dd className="mk-num">{s.avg_return_pct > 0 ? '+' : ''}{s.avg_return_pct.toFixed(2)}%</dd></div>
    </dl>
    <p className="mk-fine">{s.hit_rule} Historical results do not guarantee future performance.</p>
  </>
);

const Soon = () => (
  <div className="mk-tr-soon" data-testid="track-record-soon">
    <Hourglass size={20} aria-hidden="true" />
    <p><b>Public track record launching soon.</b> We will publish results once enough outlooks have been graded to be meaningful.</p>
  </div>
);

export const TrackRecordTeaser = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/public/track-record-summary`).then((r) => (r.ok ? r.json() : null))
      .then((j) => setS(j || { eligible: false })).catch(() => setS({ eligible: false }));
  }, []);
  return (
    <section className="mk-section mk-alt" id="track-record" aria-labelledby="track-title">
      <div className="mk-container">
        <SectionHead id="track-title" eyebrow="Track record" title="Graded against what price actually did" />
        <div className="mk-card mk-tr" aria-busy={!s} data-testid="track-record-teaser">
          {!s && <div className="mk-skel mk-tr-skel" aria-hidden="true" />}
          {s && (s.eligible ? <Stats s={s} /> : <Soon />)}
          <a className="mk-link-arrow" href="/methodology" data-testid="track-methodology-link">How outlooks are graded <ArrowRight size={16} aria-hidden="true" /></a>
        </div>
      </div>
    </section>
  );
};
